import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useDownloadOwnDataExportMutation } from '@/hooks/useClientDataExport';

export function MyDataCard() {
  const { t } = useTranslation('clients');
  const downloadMutation = useDownloadOwnDataExportMutation();

  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="Shield" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('portal.myData.title')}</h2>
      </div>
      <p className="text-sm text-zoomuted mb-4">{t('portal.myData.description')}</p>
      <Button
        variant="outline"
        className="w-full sm:w-auto"
        isLoading={downloadMutation.isPending}
        onClick={function downloadMyData() {
          downloadMutation.mutate();
        }}
      >
        <Icon name="Download" />
        {t('portal.myData.download')}
      </Button>
      {downloadMutation.isError ? (
        <p role="alert" className="mt-2 text-sm text-zooerrortext">
          {t('portal.myData.error')}
        </p>
      ) : null}
    </Card>
  );
}
